import { Typography, TextField, Stack } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import useNonNullContext from '../../hooks/useNonNullContext';
import UserContext from '../../context/user';
import ConfigContext from '../../context/config';

const DEFAULT_TITLE = `See what's available in your area`;
const DEFAULT_SUBTITLE =
  'Enter your details to view meals that deliver to you.';

export default function UserDetailsForm(props: {
  control: Control<{ zipCode: string; email?: string; name?: string }>;
  formVariant: 'ZIP' | 'EMAIL_ZIP' | 'FULL' | undefined;
}) {
  const { control, formVariant } = props;

  const { user } = useNonNullContext(UserContext);
  const tenantConfig = useNonNullContext(ConfigContext);

  const title =
    tenantConfig.menuPage?.menuEntryModalConfig?.title || DEFAULT_TITLE;
  const subtitle =
    tenantConfig.menuPage?.menuEntryModalConfig?.subtitle || DEFAULT_SUBTITLE;

  return (
    <div>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {subtitle && <Typography variant={'body1'}>{subtitle}</Typography>}
      <Stack spacing={2} sx={{ mt: 3 }}>
        {formVariant === 'FULL' && (
          <Controller
            control={control}
            name="name"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                sx={{
                  width: '100%',
                  marginBottom: '1rem',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
                label="Full Name"
                variant="outlined"
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        )}
        {(formVariant === 'EMAIL_ZIP' || formVariant === 'FULL') && (
          <Controller
            control={control}
            name="email"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                sx={{
                  width: '100%',
                  marginBottom: '1rem',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
                label="Email"
                variant="outlined"
                type="email"
                // If a user is logged in the email field is disabled
                disabled={!!user}
                error={!!error}
                helperText={
                  !!user
                    ? 'Email address is linked to your user account'
                    : error?.message
                }
              />
            )}
          />
        )}
        <Controller
          control={control}
          name="zipCode"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              required
              label="Zip Code"
              fullWidth
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Stack>
    </div>
  );
}
